import { Box, Typography } from "fds";
import "./index.scss";
import { useTranslation } from "react-i18next";

import HomeTop from "./HomeTop";
import HomeBody from "./HomeBody";
import HomeBottom from "./HomeBottom";
const AdminHome: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box classes="adminHome" direction="column">
      <Box height={60}>
        <Typography type="h1">{t("admin.menu.home")}</Typography>
      </Box>
      <Box direction="column" classes="mg mt-24">
        <HomeTop />
        <HomeBody />
        <HomeBottom />
      </Box>
    </Box>
  );
};

export default AdminHome;
